import { Box, styled } from 'components/Material/index'

export const RoundedDivIcon = styled(Box)({
  zIndex: 1,
  color: '#fff',
  width: 40,
  height: 40,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center'
})
